$(document).on('click','.product-tab-link',function(){
  $('.product-slider').slick('refresh');
  // $('.product-slider-thumbnail').slick('refresh');
});
$('.product-slider').slick({
  autoplay: false,
  // variableWidth: true,
  slidesToScroll: 1,
  slidesToShow: 1,
   infinite: true,
  arrows: true,
  dots: false,
  asNavFor: '.product-slider-thumbnail',
  prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/2160/0643/files/arrow-prev.svg?v=1661836283'>",
  nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/2160/0643/files/arrow-next.svg?v=1661836288'>"
});
$('.product-slider-thumbnail').slick({
  autoplay: false,
  slidesToShow: 4,
  infinite: true,
  slidesToScroll: 1,
  asNavFor: '.product-slider',
  dots: false,
  arrows: false,
  focusOnSelect: true,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    }
  ]
});
$(document).ready(function() {
   $('label.fcolor-field').click(function() {
        $('label.fcolor-field').removeClass('color-active');
        $(this).addClass('color-active');
    });
   $('label.scolor-field').click(function() {
        $('label.scolor-field').removeClass('color-active');
        $(this).addClass('color-active');
    });
  $('label.promotion1-field').click(function() {
        $('label.promotion1-field').removeClass('promotion-active');
        $(this).addClass('promotion-active');
    });
  $('label.promotion2-field').click(function() {
        $('label.promotion2-field').removeClass('promotion-active');
        $(this).addClass('promotion-active');
    });
   $('label.fcolor-field2').click(function() {
        $('label.fcolor-field2').removeClass('color-active');
        $(this).addClass('color-active');
    });
//Checkbox select
  $('.bold_option_checkboxmulti .bold_option_value_element input:checkbox').change(function(){
   if($(this).is(':checked')) 
       $(this).parent().parent().addClass('selected-value'); 
   else 
      $(this).parent().parent().removeClass('selected-value')
  });   
});



$('.product-tabs-menu').click(function(){
   
    if($('.product-tabs-menu .tab-1').hasClass('w--current')){    
        $('.product-tabs-content .tab-1').addClass('w--tab-active');
        $('.product-tabs-content .tab-1').parent().parent().addClass('tab--active');  
    }else{
        $('.product-tabs-content .tab-1').removeClass('w--tab-active');
        $('.product-tabs-content.tab-1').parent().parent().removeClass('tab--active');
    }
    if($('.product-tabs-menu .tab-2').hasClass('w--current')){       
        $('.product-tabs-content .tab-2').addClass('w--tab-active');
        $('.product-tabs-content .tab-2').parent().parent().addClass('tab--active');
    }else{
        $('.product-tabs-content .tab-2').removeClass('w--tab-active');
        $('.product-tabs-content .tab-2').parent().parent().removeClass('tab--active');
    }
});
// $( '.product-tab-link.w-inline-block.w-tab-link' ).click(function() {
//    // $('.product-single__photo-wrapper:first-child').children().removeClass('hide')
//   //$('.single-option-selector option').click();
// });


